// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"81e0d0bfaf7576af","679":"bee9e1170c7ea52e","772":"9a9b780a2b87bc31"}[chunkId] + ".css";
};